import { TOKEN_ADDRESSES } from '@ethena/shared-ui/src/constants/Tokens'
import { useIsHydrated } from '@ethena/shared-ui/src/hooks/useIsHydrated'
import { usePollRpc } from '@ethena/shared-ui/src/hooks/usePollRpc'
import { formatBigInt, NumberType } from '@ethena/shared-ui/src/utils/formatNumbers'

import { useMemo } from 'react'
import { erc20Abi } from 'viem'
import { useReadContract } from 'wagmi'

export const useTvl = () => {
  const isHydrated = useIsHydrated()

  const { data: usdeTvlData, queryKey: usdeTvlQueryKey } = useReadContract({
    abi: erc20Abi,
    address: TOKEN_ADDRESSES.USDe,
    chainId: 1,
    functionName: 'totalSupply',
  })

  const { data: usdtbTvlData, queryKey: usdtbTvlQueryKey } = useReadContract({
    abi: erc20Abi,
    address: TOKEN_ADDRESSES.USDtb,
    chainId: 1,
    functionName: 'totalSupply',
  })

  usePollRpc({ interval: 20, queryKey: [usdeTvlQueryKey, usdtbTvlQueryKey] })

  const tvl = useMemo(() => {
    if (!isHydrated || !usdeTvlData || !usdtbTvlData) return undefined
    return formatBigInt(usdeTvlData + usdtbTvlData, 'USDe', NumberType.FiatTokenAmt)
  }, [isHydrated, usdeTvlData, usdtbTvlData])

  const usdeTvl = useMemo(() => {
    if (!isHydrated || !usdeTvlData) return undefined
    return formatBigInt(usdeTvlData, 'USDe', NumberType.FiatTokenAmt)
  }, [isHydrated, usdeTvlData])

  const usdtbTvl = useMemo(() => {
    if (!isHydrated || !usdtbTvlData) return undefined
    return formatBigInt(usdtbTvlData, 'USDe', NumberType.FiatTokenAmt)
  }, [isHydrated, usdtbTvlData])

  return { tvl, usdeTvl, usdeTvlData, usdtbTvl, usdtbTvlData }
}
